
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./TEGContactor.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function TEGContactor() {

        useEffect(() => {
  
    trackPageVisit("TEGContactor");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorE, CompressorTrendFaceplate } = useContext(CompressorContext);

const compressor = compressorE; // or A depending on page
    

    const [open, setOpen] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);

    

    

  const DEFAULT_VALVES = {
  PCV_2301: { mode: "Manual", opening: 0, sp: "", pv: "" },
  LCV_2301: { mode: "Manual", opening: 0, sp: "", pv: "" },
  LCV_2302: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("TEGContactor_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      PCV_2301: { ...DEFAULT_VALVES.PCV_2301, ...parsed.PCV_2301 },
      LCV_2301: { ...DEFAULT_VALVES.LCV_2301, ...parsed.LCV_2301 },
      LCV_2302: { ...DEFAULT_VALVES.LCV_2302, ...parsed.LCV_2302 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("TEGContactor_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO LP COMPRESSOR =================

  const [PT_4205, setPT_4205] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_4205")) || 0;
            setPT_4205(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_4205, setTT_4205] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_4205")) || 0;
            setTT_4205(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_4205, setFIC_4205] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_4205")) || 0;
            setFIC_4205(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_500, setTT_500] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_500")) || 0;
            setTT_500(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2704, setPT_2704] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2704")) || 0;
            setPT_2704(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV2301Open = valves?.XV_2301 === false;
  const isXV2302Open = valves?.XV_2302 === false;
  const isXV2303Open = valves?.XV_2303 === false;
  const isXV2304Open = valves?.XV_2304 === false;
  const isXV2305Open = valves?.XV_2305 === false;



  const TT_2300 = TT_4205;
  const FIC_2301 = FIC_4205;
  const PT_2301 = PT_4205;

  const FIC_2303 = isXV2301Open ? FIC_2301 * (valveData?.PCV_2301?.opening || 0)/100 : 0;

  const FIC_2302 = isXV2301Open ? FIC_2301 - FIC_2303 : 0;

  const CO_2301 = isXV2301Open ? 120 : 0;

  const PT_2302 = PT_2704;
  const TT_2302 = 30.453;

  const PT_23031 = isXV2301Open ? PT_2301 : 0.03;

  const TT_2301 = isXV2301Open ? TT_2300 : 22;

  const FIC_2304 = FIC_2302 * 0.98;

  const TT_23021 = TT_500;

  const PT_2303 = PT_23031;
  
  const FIC_230111 = 14.234;


  // ======================================================
// GAS / LEAN TEG COOLER
// ======================================================

/*
  TT_23021
  =
  LEAN TEG INLET TEMPERATURE

  TT_2302
  =
  LEAN TEG OUTLET TEMPERATURE

  TT_2301
  =
  GAS INLET TEMPERATURE

  TT_2303
  =
  GAS OUTLET TEMPERATURE
*/

// ======================================================
// OUTPUT VARIABLE
// ======================================================

let TT_2303 = 30.12;

// ======================================================
// LEAN TEG COOLING EFFECT
// ======================================================

/*
  Hotter lean TEG
  =
  more heating of gas

  Cooler lean TEG
  =
  better gas cooling
*/

// ======================================================
// TEMPERATURE DIFFERENCE
// ======================================================

const deltaTEG =
  TT_23021 - 30;



let heatTransferFactor = 0.18;

// ======================================================
// ESTIMATE GAS OUTLET TEMP
// ======================================================

TT_2303 =
  TT_2301 +
  (deltaTEG * heatTransferFactor * 4.3);

// ======================================================
// REALISTIC STABILIZATION
// ======================================================

/*
  Gas/Glycol exchangers
  usually stabilize near
  30°C
*/

if (TT_2303 < 28)
  TT_2303 = 28;

if (TT_2303 > 80)
  TT_2303 = 80;

// ======================================================
// SMALL PROCESS DAMPING
// ======================================================

TT_2303 =
  (TT_2303 * 0.92) +
  (30.12 * 0.08);

// ======================================================
// OPTIONAL LOCAL STORAGE
// ======================================================

localStorage.setItem(
  "TT_2303",
  TT_2303
);


// ======================================================
// TEG CONTACTOR WATER REMOVAL LOGIC
// ======================================================

/*
  CO_2301
  =
  GAS INLET WATER CONTENT
  (lb/MMscf)

  CO_2302
  =
  GAS OUTLET WATER CONTENT
  AFTER TEG CONTACTOR

  FIC_230111
  =
  LEAN TEG FLOWRATE
*/

// ======================================================
// OUTPUT VARIABLE
// ======================================================

let CO_2302 = CO_2301;

// ======================================================
// LEAN TEG FLOW RATIO
// ======================================================

/*
  Maximum effective TEG flow
  ≈ 14.234
*/

const tegFlowRatio =
  Math.min(
    FIC_230111 / 14.234,
    1
  );

// ======================================================
// DEHYDRATION EFFICIENCY
// ======================================================

/*
  More LEAN TEG flow
  =
  better water removal
*/

let dehydrationEfficiency =
  0.10 + (tegFlowRatio * 0.96);

/*
  Range:
  10%  → poor dehydration
  98%  → excellent dehydration
*/

// ======================================================
// WATER CONTENT REDUCTION
// ======================================================

CO_2302 =
  CO_2301 *
  (1 - dehydrationEfficiency);

// ======================================================
// REALISTIC OPERATING CORRECTIONS
// ======================================================

// HIGH LEAN TEG FLOW
if (FIC_230111 >= 12) {

  CO_2302 =
    Math.max(
      4.5,
      CO_2302 * 0.35
    );
}

// MEDIUM FLOW
else if (FIC_230111 >= 7) {

  CO_2302 =
    Math.max(
      8,
      CO_2302 * 0.60
    );
}

// LOW FLOW
else if (FIC_230111 >= 3) {

  CO_2302 =
    Math.max(
      20,
      CO_2302 * 0.85
    );
}

// VERY LOW FLOW
else {

  CO_2302 =
    CO_2301 * 0.95;
}

// ======================================================
// FINAL OPERATING LIMITS
// ======================================================

/*
  Prevent unrealistic values
*/

if (CO_2302 < 4.5)
  CO_2302 = 4.5;

if (CO_2302 > CO_2301)
  CO_2302 = CO_2301;

// ======================================================
// OPTIONAL LOCAL STORAGE
// ======================================================

localStorage.setItem(
  "CO_2302",
  CO_2302
);


// ======================================================
// CONVERT WATER CONTENT
// lb/MMscf  →  ppmv
// ======================================================
/*
  Approximate conversion:

  ppmv ≈ (lb/MMscf × 7.94)

  Example:
  4.5 lb/MMscf
  ≈ 35.7 ppmv
*/

let CO_2303 =
  CO_2302 * 7.94;

// ======================================================
// REALISTIC LIMITS
// ======================================================

if (CO_2303 < 0)
  CO_2303 = 0;


  const FIC_2308 = isXV2302Open ? 30.543 * (valveData?.LCV_2302?.opening || 0)/100 : 0;

  const PT_2305 = isXV2302Open ? 0.721 * (valveData?.LCV_2302?.opening || 0)/100 : 0;
  const TT_2307 = isXV2302Open ? 30.32 : 26;


    const FIC_2306 = isXV2304Open ? 30.24 : 0;
    const TT_2306 = isXV2304Open ? 24 : 28;
    const PT_2306 = isXV2304Open ? 1.3 : 0.03;


    // ======================================================
// TEG GAS COOLER (GAS / WATER HEAT EXCHANGER)
// ======================================================

// ======================================================
// OUTPUT VARIABLES
// ======================================================

let FIC_2305 = 0; // GAS OUTLET FLOW
let TT_2304 = 25; // GAS OUTLET TEMP

let FIC_2309 = 0; // WATER OUTLET FLOW
let TT_2309 = 25; // WATER OUTLET TEMP

// ======================================================
// CHECK WATER SUPPLY VALVE
// ======================================================

/*
  Example:
  const isXV2304Open = valves?.XV_2306 === false;
*/

// ======================================================
// CASE 1
// GAS NOT FLOWING
// ======================================================

if (FIC_2304 <= 0) {

  FIC_2305 = 0;

  TT_2304 = TT_2303;

  FIC_2309 = 0;

  TT_2309 = TT_2306;
}

// ======================================================
// CASE 2
// GAS FLOWING BUT WATER CLOSED
// ======================================================

else if (!isXV2304Open || FIC_2306 <= 0) {

  // ==========================================
  // NO COOLING
  // ==========================================

  FIC_2305 =
    FIC_2304 * 0.998;

  TT_2304 =
    TT_2303;

  // ==========================================
  // NO WATER FLOW
  // ==========================================

  FIC_2309 = 0;

  TT_2309 =
    TT_2306;
}

// ======================================================
// CASE 3
// NORMAL HEAT EXCHANGE
// ======================================================

else {

  // ====================================================
  // EFFECTIVE WATER/GAS RATIO
  // ====================================================

  const exchangerRatio =
    FIC_2306 / (FIC_2304 + 1);

  // ====================================================
  // COOLING EFFICIENCY
  // ====================================================

  /*
    More cooling water
    =
    better gas cooling
  */

  let coolingEfficiency =
    exchangerRatio * 0.68;

  // ====================================================
  // LIMITS
  // ====================================================

  if (coolingEfficiency > 0.82)
    coolingEfficiency = 0.82;

  if (coolingEfficiency < 0.12)
    coolingEfficiency = 0.12;

  // ====================================================
  // TEMPERATURE DIFFERENCE
  // ====================================================

  const deltaT =
    TT_2303 - TT_2306;

  // ====================================================
  // GAS COOLING
  // ====================================================

  const gasCooling =
    deltaT * coolingEfficiency;

  // ====================================================
  // GAS OUTLET TEMPERATURE
  // ====================================================

  TT_2304 =
    TT_2303 - gasCooling;

  // ====================================================
  // REALISTIC MINIMUM LIMIT
  // ====================================================

  /*
    Gas cannot cool below
    cooling-water approach temp
  */

  const minimumGasTemp =
    TT_2306 + 5;

  if (TT_2304 < minimumGasTemp) {

    TT_2304 =
      minimumGasTemp;
  }

  // ====================================================
  // WATER HEATING
  // ====================================================

  /*
    Water absorbs heat from gas
  */

  const waterTempRise =
    gasCooling * 0.45;

  TT_2309 =
    TT_2306 + waterTempRise;

  // ====================================================
  // WATER MAXIMUM LIMIT
  // ====================================================

  if (TT_2309 > 55)
    TT_2309 = 55;

  // ====================================================
  // FLOW LOSSES
  // ====================================================

  FIC_2305 =
    FIC_2304 * 0.997;

  FIC_2309 =
    FIC_2306 * 0.998;
}

// ======================================================
// OPTIONAL STORAGE
// ======================================================

    useEffect(() => {
        localStorage.setItem("FIC_2305", FIC_2305);
        }, [FIC_2305]);

    useEffect(() => {
        localStorage.setItem("FIC_2303", FIC_2303);
        }, [FIC_2303]);

    useEffect(() => {
        localStorage.setItem("TT_2304", TT_2304);
        }, [TT_2304]);

    useEffect(() => {
        localStorage.setItem("PT_2303", PT_2303);
        }, [PT_2303]);

    useEffect(() => {
        localStorage.setItem("FIC_2308", FIC_2308);
        }, [FIC_2308]);

    useEffect(() => {
        localStorage.setItem("PT_2305", PT_2305);
        }, [PT_2305]);

    useEffect(() => {
        localStorage.setItem("TT_2307", TT_2307);
        }, [TT_2307]);

        





 


  return (
    <div className="TEGContactor-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 300px"
      }}>
       TEG CONTACTOR UNIT
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-2301"
        tag="XV_2301"
        x={195}
        y={412}
        isClosed={valves.XV_2301}
        toggle={toggleValve}
      />

      {/* XV-2302 */}
      <Valve
        className="XV-2302"
        tag="XV_2302"
        x={608}
        y={512}
        isClosed={valves.XV_2302}
        toggle={toggleValve}
      />

      {/* XV-2303 */}
      <Valve
        className="XV-2303"
        tag="XV_2303"
        x={304}
        y={606}
        isClosed={valves.XV_2303}
        toggle={toggleValve}
      />

      {/* XV-2304 */}
      <Valve
        className="XV-2304"
        tag="XV_2304"
        x={1176}
        y={535}
        isClosed={valves.XV_2304}
        toggle={toggleValve}
      />

     

      

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* PCV-2301 */}
        <svg width="80" height="50" viewBox="0 0 230 220" className="PCV-2301"
          style={{ position: "absolute", left: 152, top: 64}}  onClick={() => openPanel("PCV_2301")}>
          
          <defs>
            <linearGradient id="metal_2301">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,230 100,150 20,110"
            fill="url(#metal_2301)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,230 100,150 180,110"
            fill="url(#metal_2301)" stroke="#7f8c8d" strokeWidth="2" />
          </svg>
        
         {/* LCV-2301 */}
        <svg width="80" height="50" viewBox="0 0 230 220" className="LCV-2301"
          style={{ position: "absolute", left: 140, top: 597}}  onClick={() => openPanel("LCV_2301")}>
          
          <defs>
            <linearGradient id="metal_2301">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,230 100,150 20,110"
            fill="url(#metal_2301)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,230 100,150 180,110"
            fill="url(#metal_2301)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* LCV-2302 */}
        <svg width="80" height="50" viewBox="0 0 230 220" className="LCV-2302"
          style={{ position: "absolute", left: 514, top: 764}}  onClick={() => openPanel("LCV_2302")}>
          
          <defs>
            <linearGradient id="metal_2302">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,230 100,150 20,110"
            fill="url(#metal_2302)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,230 100,150 180,110"
            fill="url(#metal_2302)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

        

        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.PCV_2301?.opening || 0)}
        x={175}
        y={115}
      />

      <ValveOutput
        value={Number(valveData?.LCV_2301?.opening || 0)}
        x={160}
        y={643}
      />
      <ValveOutput
        value={Number(valveData?.LCV_2302?.opening || 0)}
        x={536}
        y={815}
      />

      


          {/* ================= TRANSMITTERS OUTPUTS ================= */}


          <Transmitter
            tag="FIC-2301"
            value={[FIC_2301]}
            x={106}
            y={394}
            unit="SCF/S"
            max={300}
            HH={290}
            H={285}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF GAS FROM DEHYDRATION FEED GAS K. O. DRUM TO TEG CONTACTOR"
          />

          <Transmitter
            tag="PT-2301"
            value={[PT_2301]}
            x={106}
            y={479}
            unit="MPa"
            max={5}
            HH={4.8}
            H={4.1}
            L={0.04}
            LL={0.01}
            c="lime"
            description="PRESSURE OF GAS FROM DEHYDRATION FEED GAS K. O. DRUM TO TEG CONTACTOR"
          />
          
          <Transmitter
            tag="TT-2300"
            value={[TT_2300]}
            x={110}
            y={355}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF GAS FROM DEHYDRATION FEED GAS K. O. DRUM TO TEG CONTACTOR"
          />

          <Transmitter
            tag="FIC-2302"
            value={[FIC_2302]}
            x={266}
            y={394}
            unit="SCF/S"
            max={300}
            HH={290}
            H={285}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF GAS FROM DEHYDRATION FEED GAS K. O. DRUM TO INLET OF TEG CONTACTOR"
          />
      
          <Transmitter
            tag="FIC-2303"
            value={[FIC_2303]}
            x={126}
            y={172}
            unit="SCF/S"
            max={100}
            HH={90}
            H={85}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF GAS FROM DEHYDRATION FEED GAS K. O. DRUM VIA INLET OF TEG CONTACTOR TO FLARE HEADER"
          />
      
          <Transmitter
            tag="CO-2301"
            value={[CO_2301]}
            x={261}
            y={348}
            unit="lb/MMscf"
            max={150}
            HH={140}
            H={130}
            L={3}
            LL={1}
            c="lime"
            description="CONCENTRATION OF WATER IN GAS AT THE INLET OF TEG CONTACTOR"
          />

          <Transmitter
            tag="CO-2302"
            value={[CO_2302]}
            x={637}
            y={133}
            unit="lb/MMscf"
            max={15}
            HH={10}
            H={60}
            L={1}
            LL={0.5}
            c="lime"
            description="CONCENTRATION OF WATER IN GAS AT THE DISCHARGE OF TEG CONTACTOR"
          />

          <Transmitter
            tag="CO-2303"
            value={[CO_2303]}
            x={637}
            y={148}
            unit="ppmv"
            max={100}
            HH={85}
            H={60}
            L={1}
            LL={0.5}
            c="lime"
            description="CONCENTRATION OF WATER IN GAS AT THE DISCHARGE OF TEG CONTACTOR"
          />

          <Transmitter
            tag="PT-2302"
            value={[PT_2302]}
            x={466}
            y={112}
            unit="MPa"
            max={5}
            HH={4.8}
            H={4.1}
            L={0.04}
            LL={0.01}
            c="lime"
            description="PRESSURE OF LEAN TEG FROM TEG REBOILER TO TEG CONTACTOR"
          />
          
          <Transmitter
            tag="TT-2302"
            value={[TT_2302]}
            x={466}
            y={145}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF LEAN TEG FROM TEG/LEAN GAS AFTER COOLER TO TEG CONTACTOR"
          />
      
          <Transmitter
            tag="TT-2301"
            value={[TT_2301]}
            x={341}
            y={148}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF GAS AT THE OVERHEAD OF TEG CONTACTOR TO GAS/LEAN TEG AFTER COOLER"
          />
      
          <Transmitter
            tag="TT-23021"
            value={[TT_23021]}
            x={572}
            y={252}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF LEAN TEG FROM TEG REBOILER TO TEG CONTACTOR"
          />

          <Transmitter
            tag="PT-23031"
            value={[PT_23031]}
            x={336}
            y={103}
            unit="MPa"
            max={5}
            HH={4.8}
            H={4.1}
            L={0.04}
            LL={0.01}
            c="lime"
            description="PRESSURE OF GAS AT THE OVERHEAD OF TEG CONTACTOR TO GAS/LEAN TEG AFTER COOLER"
          />

          <Transmitter
            tag="FIC-2304"
            value={[FIC_2304]}
            x={583}
            y={357}
            unit="SCF/S"
            max={300}
            HH={290}
            H={285}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF DEHYDRATED GAS AT THE DISCHARGE OF GAS/LEAN TEG AFTER COOLER TO TEG GAS COOLER"
          />

          <Transmitter
            tag="TT-2303"
            value={[TT_2303]}
            x={839}
            y={152}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF DEHYDRATED GAS AT THE DISCHARGE OF GAS/LEAN TEG AFTER COOLER TO TEG GAS COOLER"
          />

          <Transmitter
            tag="PT-2303"
            value={[PT_2303]}
            x={839}
            y={102}
            unit="MPa"
            max={5}
            HH={4.8}
            H={4.1}
            L={0.04}
            LL={0.01}
            c="lime"
            description="PRESSURE OF DEHYDRATED GAS AT THE DISCHARGE OF GAS/LEAN TEG AFTER COOLER TO TEG GAS COOLER"
          />

          <Transmitter
            tag="FIC-2308"
            value={[FIC_2308]}
            x={343}
            y={757}
            unit="LPM"
            max={20}
            HH={18}
            H={15}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF RICH TEG AT THE BOTTOM OF TEG CONTACTOR TO TEG GAS REBOILER"
          />

          <Transmitter
            tag="TT-2307"
            value={[TT_2307]}
            x={729}
            y={757}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF RICH TEG AT THE BOTTOM OF TEG CONTACTOR TO TEG GAS REBOILER"
          />

          <Transmitter
            tag="PT-2305"
            value={[PT_2305]}
            x={219}
            y={757}
            unit="MPa"
            max={5}
            HH={4.8}
            H={4.1}
            L={0.04}
            LL={0.01}
            c="lime"
            description="PRESSURE OF RICH TEG AT THE BOTTOM OF TEG CONTACTOR TO TEG GAS REBOILER"
          />

          <Transmitter
            tag="FIC-2309"
            value={[FIC_2309]}
            x={1053}
            y={100}
            unit="LPM"
            max={70}
            HH={80}
            H={60}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF FRESH WATER FROM WATER SUPPLY LINE AT THE DISCHARGE TEG GAS COOLER"
          />

          <Transmitter
            tag="TT-2309"
            value={[TT_2309]}
            x={1153}
            y={100}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF FRESH WATER FROM WATER SUPPLY LINE AT THE DISCHARGE TEG GAS COOLER"
          />

          <Transmitter
            tag="FIC-2306"
            value={[FIC_2306]}
            x={983}
            y={519}
            unit="LPM"
            max={70}
            HH={80}
            H={60}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF FRESH WATER FROM WATER SUPPLY LINE AT THE INLET TEG GAS COOLER"
          />

          <Transmitter
            tag="TT-2306"
            value={[TT_2306]}
            x={1073}
            y={519}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF FRESH WATER FROM WATER SUPPLY LINE AT THE INLET TEG GAS COOLER"
          />

          <Transmitter
            tag="PT-2306"
            value={[PT_2306]}
            x={853}
            y={519}
            unit="MPa"
            max={5}
            HH={4.8}
            H={4.1}
            L={0.04}
            LL={0.01}
            c="lime"
            description="PRESSURE OF FRESH WATER FROM WATER SUPPLY LINE AT THE INLET TEG GAS COOLER"
          />

          <Transmitter
            tag="FIC-2305"
            value={[FIC_2305]}
            x={1063}
            y={404}
            unit="LPM"
            max={70}
            HH={80}
            H={60}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF DEHYDRATED GAS AT THE OUTLET OF THE TEG GAS COOLER TO EXPORT COMPRESSOR K. O. DRUM"
          />

          <Transmitter
            tag="TT-2304"
            value={[TT_2304]}
            x={963}
            y={404}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF DEHYDRATED GAS AT THE OUTLET OF THE TEG GAS COOLER TO EXPORT COMPRESSOR K. O. DRUM"
          />



    <LevelTransmitterIndicator
      tag="LT_2301"
      totalLevel={40000}
      inflows={[FIC_230111 + FIC_2302*0.08]}
      outflows={[FIC_2308]}
      responseFactor={0.05}
      columnX={386}
      columnY={243}
      columnWidth={94}
      columnHeight={310}
      textX={500}
      textY={409}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />
      
      



      
       

    </div>
  );
}


export default TEGContactor;